export const DATA_HOOKS = {
  root: 'groups-page',
};
